import { render, staticRenderFns } from "./teamList.vue?vue&type=template&id=3a04d9c0&scoped=true"
import script from "./teamList.vue?vue&type=script&lang=js"
export * from "./teamList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a04d9c0",
  null
  
)

export default component.exports